import { FC } from 'react';
import { CurrentSpend } from './current-spend/current-spend';
import { BillingHistory } from './billing-history/billing-history';
import cls from './billing.module.scss';

export const Billing: FC = () => {
  return (
    <div className={cls.billingTab}>
      <CurrentSpend />
      <BillingHistory />
    </div>
  );
};
